export function getUIVersionCookie(cookie = UI_VERSION_COOKIE_NAME) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + cookie + "=");
    if (parts.length === 2) {
        return parts.pop().split(";").shift();
    }
}

export const getUiVersion = (cookie = UI_VERSION_COOKIE_NAME) => {
    const uiVersion =
        localStorage && localStorage.getItem(DISABLE_FLAG) === true.toString() ? null : getUIVersionCookie(cookie);
    return uiVersion;
};

export const getUiBranch = () => getUiVersion(UI_BRANCH_COOKIE_NAME);

const UI_VERSION_COOKIE_NAME = "X-SW-UI-Version";
const UI_BRANCH_COOKIE_NAME = "X-SW-UI-Branch";
const DISABLE_FLAG = "disableUIVersionIndicator";
